import React from 'react';
import { describe } from '@elliemae/ds-props-helpers';
import { DSButton } from '../SharedButtonBaseline/index.js';
import type { DSButtonV3T } from './react-desc-prop-types.js';
import { DSButtonV3PropTypesSchema } from './react-desc-prop-types.js';
import { DSButtonV3Name } from './DSButtonV3Definitions.js';

const DSButtonV3: React.ComponentType<DSButtonV3T.Props> = ({ children, ...otherProps }) => (
  <DSButton {...otherProps} isV3>
    {children}
  </DSButton>
);

DSButtonV3.displayName = DSButtonV3Name;
const DSButtonV3WithSchema = describe(DSButtonV3);
DSButtonV3WithSchema.propTypes = DSButtonV3PropTypesSchema;

export { DSButtonV3, DSButtonV3WithSchema };
